export default {
  fi: {
    LoginScene: {
      title: 'Admin',
      login: 'Kirjaudu',
      tokenSent: 'Linkki lähetetty sähköpostiin',
    },
  },
};
